{
  "account": {
    "menu": {
      "trigger": "Account: {{name}}",
      "profile": "My profile",
      "vendorAccount": "My account",
      "language": "Display language"
    },
    "nav": {
      "profile": "My profile"
    },
    "passwordField": {
      "show": "Show password"
    },
    "notRecorded": "Not recorded",
    "profile": {
      "title": "My profile",
      "subtitle": "Your account in {{organisation}}",
      "aboutTitle": "About you",
      "aboutNote": "Your organisation's administrator keeps your email address, phone and job title up to date.",
      "status": "Account status",
      "accessTitle": "Your organisation and access",
      "organisation": "Organisation",
      "roles": "Roles",
      "noRoles": "No roles assigned",
      "scope": "Where you work",
      "defaultNode": "Default purchasing unit",
      "timezone": "Time zone",
      "timezoneHint": "Set by your organisation",
      "accessNote": "Only your organisation's administrator can change your roles and where you work.",
      "otherOrganisation": "Work with another organisation on Fidelen? Sign out, then sign in again: the organisations your password opens are offered then.",
      "securityTitle": "Sign-in security",
      "openSecurity": "Open sign-in security"
    },
    "preferences": {
      "title": "Preferences",
      "subtitle": "What you can change yourself",
      "name": "Name",
      "nameHint": "How your name appears to others in Fidelen, for example on approvals.",
      "nameAr": "Name (Arabic)",
      "nameArHint": "Shown to people who use Fidelen in Arabic.",
      "locale": "Language for emails and notifications",
      "localeHint": "The language Fidelen writes to you in. The language switch at the top of the screen changes only what this device shows.",
      "save": "Save preferences",
      "saved": "Your preferences were saved.",
      "unchanged": "Nothing has changed yet.",
      "refusedTitle": "Your preferences were not saved",
      "nameRequired": "Enter your name.",
      "tooLong": "Use 150 characters or fewer."
    },
    "password": {
      "title": "Password",
      "subtitle": "This changes your password for {{organisation}} only.",
      "current": "Current password",
      "new": "New password",
      "newHintPlain": "Use letters and numbers.",
      "breachHint": "Passwords found in known data breaches are refused.",
      "confirm": "Confirm new password",
      "submit": "Change password",
      "changed": "Your password was changed. Anywhere else this account was signed in now needs the new password.",
      "refusedTitle": "Your password was not changed",
      "currentRequired": "Enter your current password.",
      "newRequired": "Enter a new password.",
      "confirmRequired": "Enter the new password again.",
      "mismatch": "The two new passwords do not match.",
      "sameAsCurrent": "Choose a password different from your current one.",
      "throttled": "Too many attempts. Wait a few minutes, then try again.",
      "newHint_zero": "At least {{count}} characters, with letters and numbers.",
      "tooShort_zero": "Use at least {{count}} characters.",
      "newHint_one": "At least {{count}} character, with letters and numbers.",
      "tooShort_one": "Use at least {{count}} character.",
      "newHint_two": "At least {{count}} characters, with letters and numbers.",
      "tooShort_two": "Use at least {{count}} characters.",
      "newHint_few": "At least {{count}} characters, with letters and numbers.",
      "tooShort_few": "Use at least {{count}} characters.",
      "newHint_many": "At least {{count}} characters, with letters and numbers.",
      "tooShort_many": "Use at least {{count}} characters.",
      "newHint_other": "At least {{count}} characters, with letters and numbers.",
      "tooShort_other": "Use at least {{count}} characters.",
      "symbolHint": "Include a symbol.",
      "platformSubtitle": "This changes your Fidelen operator password only."
    },
    "vendor": {
      "title": "My account",
      "subtitle": "Your sign-in to the supplier portal of {{buyer}}",
      "youTitle": "You",
      "companyTitle": "Your company",
      "supplier": "Company",
      "buyer": "Organisation you supply",
      "openCompanyDetails": "Open company details",
      "oneOrganisation": "This sign-in is for {{buyer}} only. Another organisation that buys from you on Fidelen gives you a separate sign-in."
    },
    "platform": {
      "subtitle": "Your Fidelen operator account",
      "role": "Role"
    }
  }
}
